import React, { useEffect, useMemo, useState } from 'react';
import Modal from '@components/common/Modal';
import FullWithModal from '@components/common/Modal/FullWidthModal';
import { CUSTOM_MESSAGES, LABEL } from '../../../veriables';
import cn from 'classnames';
import styles from '../../TablePopUp/modal.module.scss';
const RepostPaymentModal = (props) => {

  // Props Destructuring
  const {
    serverAppTheme,
    isOpen,
    onClose,
    tHead,
    rowData,
    isRepostOpen,
    setRepostConfirmation,
    setSelectedItem,
    repostPayments,
    repostConfirmation
  } = props;

  // State Management
  const [checkArray, setCheckArray] = useState([]);
  const [data, setData] = useState([]);
  const [replaceData, setReplaceData] = useState([]);



  // React Hooks
  const repostPaymentStyle = useMemo(() => {
    const repostButton = {
      backgroundColor:serverAppTheme?.secondaryBtn,
      color: serverAppTheme?.btn_font_color,
      borderRadius: "8px",
    };
    const cancelButton = {
      backgroundColor: serverAppTheme?.OFF_Premise_Btn,
      border: serverAppTheme?.cancleBtn_Border,
      color: serverAppTheme?.cancleBtn_font,
      borderRadius: "8px",
    };
    const repostBtnContainer = { padding: "0 60px" };
    return { cancelButton, repostButton, repostBtnContainer };
  }, [serverAppTheme, checkArray]);

  const tableHead = tHead?.filter((x) => x.key !== 'printStatus');

  useEffect(() => {
    const ticketsData = rowData.tickets.map((item) => {
      let ticket = {};
      ticket = {
        ...item,
        checkbox:
          <input
            className={cn('d-flex justify-content-center roundedSm', styles.checkboxPotrait)}
            style={{
              border: !(checkArray.some((e) => e === item.id)) && `2px solid ${serverAppTheme?.primary_text}`,
              '--checkbox-checked-color': serverAppTheme?.checkbox_check_color,
              '--checkbox-checked-bg': serverAppTheme?.checkbox_checked,
              opacity: isRepostOpen && !item.enableRepostPos && "0.2"
            }}
            type="checkbox"
            disabled={isRepostOpen && !item.enableRepostPos}
            checked={checkArray.some((e) => e === item.id)}
            onChange={() => { handleCheckBox(item.id); setSelectedItem(item) }}
          />
      }
      return { ...ticket };
    });
    if (data.length > 0) {
      setReplaceData(replaceData.concat(ticketsData));
      setData([]);
    } else {
      setReplaceData([]);
      setData(data.concat(ticketsData.filter((e) => Object.keys(e).length > 0)));
    }
  }, [rowData, checkArray]);

  // Methods

  const handleCheckBox = (e) => {
    if (!checkArray.includes(e)) {
      setCheckArray(checkArray.splice(0));
      setCheckArray(checkArray.concat(e));
    } else {
      setCheckArray(checkArray.filter((f) => f !== e));
    }
  };

  const tableHeader = () => {
    return (
      tableHead &&
      tableHead.map((item) => {
        return (
          <div
            key={item.name}
            className={cn(
              "col border-5 fw-500 fs_14 text-left",
              item.key === "checkbox"
                ? "col-1 pl-2 pr-1"
                : item.key === "paymentStatus"
                  ? "pr-2 pl-1"
                  : "px-1",
            )}
          >
            {item.name}
          </div>
        );
      })
    );
  };

  const tBody = () => {
    if (data.length > 0) {
      return data
        .filter((f) => Object.keys(f).length > 0)
        .map((e, index) => {
          return (
            <div
              key={e.id}
              className={cn(
                "col-12 px-0 row mx-0  fs_14",
                checkArray.some((ele) => ele === e.id) ? `fs_14` : "",
              )}
              style={{
                borderBottom:
                  index !== data.length - 1 && serverAppTheme?.popupBorder,
                background:
                  checkArray.some((ele) => ele === e.id) &&
                  serverAppTheme?.receipt_select_bg,
              }}
            >
              {tableHead &&
                tableHead.map((item) => {
                  return (
                    <div
                      className={cn(
                        styles.rowPadding,
                        "col py-2 border-5 fs_14 text-left",
                        item.key === "checkbox"
                          ? "col-1 pl-2 pr-1 "
                          : item.key === "paymentStatus"
                            ? "pr-2 pl-1"
                            : "px-1",
                        styles.wordBreak,
                      )}
                      key={item.key}
                    >
                      {item.prefix
                        ? `${item.prefix}${Number(e[item.key]).toFixed(2)}`
                        : e[item.key]}
                    </div>
                  );
                })}
            </div>
          );
        });
    }
    return replaceData
      .filter((f) => Object.keys(f).length > 0)
      .map((e, index) => {
        return (
          <div
            key={e.id}
            className={cn(
              "col-12 px-0 row mx-0 fs-14",
              checkArray.some((ele) => ele === e.id) ? `fs_14` : "",
            )}
            style={{
              borderBottom:
                index !== data.length - 1 && serverAppTheme?.popupBorder,
              background:
                checkArray.some((ele) => ele === e.id) &&
                serverAppTheme?.receipt_select_bg,
            }}
          >
            {tableHead &&
              tableHead.map((item) => {
                return (
                  <div
                    className={cn(
                      "col py-2 border-5 fs_14 text-left",
                      item.key === "checkbox"
                        ? "col-1 pl-2 pr-1 "
                        : item.key === "paymentStatus"
                          ? "pr-2 pl-1"
                          : "px-1",
                      styles.wordBreak,
                      styles.rowPadding,
                    )}
                    key={item.key}
                  >
                    {item.prefix
                      ? `${item.prefix}${Number(e[item.key]).toFixed(2)}`
                      : e[item.key]}
                  </div>
                );
              })}
          </div>
        );
      });
  };

    const stationName = rowData?.stationName?.length > 8 ? rowData?.stationName?.substring(0, 8).concat('...') : rowData.stationName;
    const onHandleRepostFunc = () => {
    if (checkArray.length === 0) {
      props.setErrorPopUp({
          res: CUSTOM_MESSAGES().REPOST_ERROR,
          noErrorTxt: true,
        });
    }
    else {
      setRepostConfirmation(true);
    }
  }

  return (
    <>
      <FullWithModal
        isOpen={isOpen}
        isModalCenter
        customClass2={cn("w-100 h-100 position-relative")}
        noBackground
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: "100%",
          pointerEvents: "auto",
          backgroundColor: serverAppTheme?.popUp_bg,
          backgroundClip: "padding-box",
          border: serverAppTheme?.popupBorder,
          boxShadow: serverAppTheme?.popUp_box_shadow,
        }}
      >
        <div
          className={cn(
            "col-12 m-auto justify-content-center align-items-center text-center pb-3 px-0",
          )}
          style={{ color: serverAppTheme?.primary_text }}
        >
           <div className={cn('col-12 fw-600 fs_18 d-flex py-1 px-2', styles.moretitlebg)}>
            <div className={cn('fs_18 fw-600 col-4 p-0 text-left')}>{rowData?.tab ? 'Tab' :'Table'} : {stationName}</div>
              <div className='col-4 p-0 text-center'>Repost Payment</div>
            <div className={cn('fs_18 fw-600 col-4 p-0 text-right')}># {rowData?.number}</div>
            </div>
          <div className={cn("col-12 px-3")}>
            <div className="col-12 px-0 text-left fw-600 text-center pb-2 pt-3 fs_18">{LABEL().REPOST_SELECT_CARD}</div>
            <div
              className={cn(
                "col-12 row mx-0 p-0 justify-content-center",
                styles.tablecontainer,
              )}
              style={{
                maxHeight: "320px",
                border: serverAppTheme?.popupBorder,
              }}
            >
              <div
                className={cn(
                  "col-12 px-0 fs_14 rounded-top position-sticky",
                  styles.positionValue,
                )}
                style={{
                  background: serverAppTheme?.popUp_bg,
                  borderBottom: serverAppTheme?.popupBorder,
                }}
              >
                <div
                  className="row mx-0"
                >
                  {tableHeader()}
                </div>
              </div>
              <div className="col-12 px-0">
                {tBody()}
              </div>
            </div>
          </div>
          <div
            className={cn(
              "row fs-18 mt-3 col-12 justify-content-center px-0 position-absolute",
            )}
            style={{
              bottom: "16px",
            }}
          >
            <div
              className={cn(
                "col-12 row mx-0 align-items-center position-relative justify-content-center text-center w-100 h-15 pt-3",
              )}
              style={repostPaymentStyle.repostBtnContainer}
            >
              <div className={cn("col-5 pl-0 pr-2")}>
                <button
                  className="btn44 fw-600 col-12 px-0 fs_24"
                  type="button"
                  onClick={() => {
                    onClose();
                  }}
                  style={repostPaymentStyle.cancelButton}
                >
                  {LABEL().CANCEL}
                </button>
              </div>
              <div className={cn("col-5 pl-0 pr-2")}>
                <button
                  className="btn44 fw-600 col-12 px-0"
                  type="button"
                  onClick={() => {
                    onHandleRepostFunc();
                  }}
                  style={repostPaymentStyle.repostButton}
                >
                  {CUSTOM_MESSAGES().REPOST_PAY}
                </button>
              </div>
            </div>
          </div>
        </div>
      </FullWithModal>
      <Modal
        isOpen={repostConfirmation}
        isModalCenter={true}
        noBackground
        style={{
          width: "418px",
          minHeight: "222px",
          border: serverAppTheme?.popupBorder,
          boxShadow: serverAppTheme?.popUp_box_shadow,
          backgroundColor: serverAppTheme?.popUp_bg,
          borderRadius: "16px",
          margin: "auto",
        }}
      >
        <div
          className="col-12 m-auto justify-content-center align-items-center position-relative text-center"
          style={{ color: serverAppTheme?.primary_text }}
        >
          <div className="col-12 fs_15 mt-10 fw-400 text-center">
            <div>{CUSTOM_MESSAGES().REPOST_CONFIRMATION}</div>
          </div>
          <div className="col-12 mt-4 d-flex justify-content-center">
            <button
              type="submit"
              className={cn("col-6 m-2 btn44")}
              onClick={() => setRepostConfirmation(false)}
              style={{
                backgroundColor: serverAppTheme?.OFF_Premise_Btn,
                border: serverAppTheme?.cancleBtn_Border,
                color: serverAppTheme?.cancleBtn_font,
                height: "44px",
              }}
            >
              <div className="fs_24 fw-600">{CUSTOM_MESSAGES().REPOST_NO}</div>
            </button>
            <button
              type="submit"
              className={cn("col-6 m-2 btn44")}
              onClick={() => {
                repostPayments()
              }}
              style={{
                backgroundColor: serverAppTheme?.secondaryBtn,
                color: serverAppTheme?.btn_font_color,
                height: "44px",
              }}
            >
              <div className="fs_24 fw-600">{CUSTOM_MESSAGES().REPOST_YES}</div>
            </button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default React.memo(RepostPaymentModal);